import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserPageComponent } from './user-page/user-page.component';
import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { EntityListModule } from 'app/components/entity-list/entity-list.module';
import { UserFormModule } from 'app/components/user-form/user-form.module';
import { RouterModule, Routes } from '@angular/router';
import { TeamPageComponent } from './team-page/team-page.component';
import { ClientPageComponent } from './client-page/client-page.component';
import { RolePageComponent } from './role-page/role-page.component';
import { ClientFormModule } from 'app/components/client-form/client-form.module';
import { TeamFormModule } from 'app/components/team-form/team-form.module';
import { RoleFormModule } from 'app/components/role-form/role-form.module';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import { InstrumentTypePageComponent } from './instrument-type-page/instrument-type-page.component';
import {InstrumentTypeModule} from '../../components/instrument-type/instrument-type.module';
import { InstrumentModelPageComponent } from './instrument-model-page/instrument-model-page.component';
import {AppModule} from '../../app.module';
import {InstrumentModelModule} from '../../components/instrument-model/instrument-model.module';
import {ICCModule} from '../../components/icc/icc.module';
import {ICCPageComponent} from './icc-page/icc-page.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {ApiKeysPageComponent} from './api-keys-page/api-keys-page.component';

const routes: Routes = [
    {
        path     : 'user',
        component: UserPageComponent
    },
    {
        path     : 'team',
        component: TeamPageComponent
    },
    {
        path     : 'client',
        component: ClientPageComponent
    },
    {
        path     : 'role',
        component: RolePageComponent
    },
    {
        path     : 'instrumentType',
        component: InstrumentTypePageComponent
    },
    {
        path     : 'instrumentModel',
        component: InstrumentModelPageComponent
    },
    {
        path     : 'icc',
        component: ICCPageComponent
    },
    {
        path     : 'apiKeys',
        component: ApiKeysPageComponent
    }
];

@NgModule({
    declarations: [UserPageComponent, TeamPageComponent, ClientPageComponent,
        RolePageComponent, InstrumentTypePageComponent, InstrumentModelPageComponent,
    ICCPageComponent, ApiKeysPageComponent],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        FuseSidebarModule,
        FuseSharedModule,
        EntityListModule,
        UserFormModule,
        TeamFormModule,
        ClientFormModule,
        RoleFormModule,

        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatDividerModule,
        InstrumentTypeModule,
        InstrumentModelModule,
        ICCModule,
        TranslateModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatInputModule

    ]
})
export class AdminPageModule { }
